import { ref } from 'vue'
import { defineStore } from 'pinia'
import axios from 'axios'
import Honeybadger from '@honeybadger-io/js'
import { toKebabCase } from '@/utils/text'
export const useNavigationStore = defineStore('navigation', () => {
  const remoteMenuItems = ref<Array<MenuItem>>([])
  const serviceAlertTypesSkip = import.meta.env.VITE_SERVICE_ALERT_TYPES_SKIP.split(',')

  async function loadRemoteMenuItems() {
    const ticketsRemoteNavUrl = import.meta.env.VITE_GET_TICKETS_NAV_URL

    if (ticketsRemoteNavUrl) {
      try {
        const response = await axios.get(ticketsRemoteNavUrl)
        const items = response.data.map((item: ExternalMenuItem) => buildMenuItem(item))
        remoteMenuItems.value = items
      } catch (error: any) {
        Honeybadger.notify('Cannot load remote menu items', {
          context: { error: error },
          tags: 'info, remote-menu'
        })
      }
    }
  }

  function buildMenuItem(data: ExternalMenuItem): MenuItem {
    const nonMatchingCount = countNonMatchingAlerts(data)

    return {
      to: data.url,
      title: data.text,
      external: true,
      showExternalIcon: false,
      notifications: nonMatchingCount
    }
  }

  function countNonMatchingAlerts(data: ExternalMenuItem): number {
    if (data.text !== 'Service Alerts') {
      return 0
    }

    const children = Object.values(data.children).flatMap((childrenList) => childrenList)

    const count = children.filter((child) => {
      const types: string[] = child.types || []
      return !types.some((type) => serviceAlertTypesSkip.includes(toKebabCase(type)))
    }).length

    return count
  }

  return {
    remoteMenuItems,
    loadRemoteMenuItems
  }
})
